import { getFormNames, hasSubmitSucceeded, isDirty, isSubmitting } from "redux-form"

import { createSelector } from "reselect"
import { isEmpty } from "lodash"

import { INIT_STATUS } from "../../globals"
import { getPathnameWithoutLocale } from "../utils/routeUtils"
import { getCurrentLanguage } from "../locale/selectors"
import { trimSlug } from "../../components/helpers"

export const getMessages = (state: any) => state.ui.messages
export const getLocalAmendmentModalOpen = (state: any) => state.ui.localAmendmentModalOpen
export const getApplicationLoadingState = (state: any) =>
  state.ui.initStatus === INIT_STATUS.LOADING
export const getApplicationWaiting = (state: any) => state.ui.initStatus === INIT_STATUS.WAITING
export const getMenuSize = (state: any) => state.ui.menuSize
export const getMenuIsSmall = createSelector(getMenuSize, (size) => size <= 80)
export const getAnonymousMessageClosed = (state: any) => state.ui.anonymousMessageClosed
export const getAppInitStatus = (state: any) => state.ui.initStatus
export const getInitializationFinished = (state: any) =>
  state.ui.initStatus === INIT_STATUS.FINISHED
export const getAppInitFailed = (state: any) => state.ui.initStatus === INIT_STATUS.FAILED
export const getShowLocal = (state: any) => state.ui.showLocal
export const getDisplayDraft = (state: any) => state.ui.displayDraft
export const getFormModalOpenState = (state: any) => state.ui.formModalOpen
export const getFormModalCallback = (state: any) => state.ui.formModalSubmitCallback
export const getFormModalMethod = (state: any) => state.ui.formModalMethod
export const getFormMode = (state: any) => state.ui.formMode
export const getCurrentIndex = (state: any) => state.ui.currentIndex
export const getCurrentStep = (state: any) => state.ui.currentStep
export const getSearchText = (state: any) => state.ui.searchText
export const getSearchResults = (state: any) => state.ui.searchResults
export const getIsSearching = (state: any) => state.ui.isSearching
export const getProcedureDrawerOpenState = (state: any) => state.ui.procedureDrawerOpen
export const getMetaDrawerOpenState = (state: any) => state.ui.metaDrawerOpen
export const getAffixDrawerOpenState = (state: any) => state.ui.affixDrawerOpen
export const getAllActiveForms = (state: any) => getFormNames()(state)
export const getFormDirtyState = (state: any) => (form: any) => isDirty(form)(state)
export const getFormIsSubmitting = (state: any) => (form: any) => isSubmitting(form)(state)
export const getFormHasBeenSubmitted = (state: any) => (form: any) =>
  hasSubmitSucceeded(form)(state)
export const getConnectionType = (state: any) => state.ui.connectionType
export const getConnectionIsFast = createSelector(getConnectionType, (type) =>
  ["3g", "4g"].includes(type)
)
export const getInitError = (state: any) => state.ui.initError
export const getCurrentPageItem = (state: any) => state.ui.curentPageItem
export const getSearchFilters = (state: any) => state.ui.searchFilters
export const getSearchQueryPage = (state: any) => (query: any, pageNo: any) =>
  state.ui.searchPages[query] ? state.ui.searchPages[query][pageNo] || null : null
export const getSearchQueryResultCount =
  (state: any) =>
  (query: any): number =>
    state.ui.searchPages[query] ? state.ui.searchPages[query].resultCount || 0 : 0

export const getTreeDataFetched = (state: any) => state.ui.treeDataFetched

export const getContextSwitchIsAllowed = (state: any) => {
  const activeForms = getFormNames()(state)
  return state.ui.treeDataFetched && !activeForms.length
}

// TODO: rewrite this to be more consistant in updating the values
export const getAnyActiveForms = createSelector(
  [getAllActiveForms, getFormDirtyState, getFormIsSubmitting, getFormHasBeenSubmitted],
  (allActiveForms, isFormDirty, isFormSubmitting, hasFormBeenSubmitted) => {
    if (isEmpty(allActiveForms)) {
      return false
    } else {
      const activeForms = allActiveForms
        // this filtering is to prevent a prompt from appearing when redirecting after a form submission
        .filter((form) => !isFormSubmitting(form)) // exclude forms that are being submitted
        .filter((form) => !hasFormBeenSubmitted(form)) // and exclude already submitted forms

      return activeForms.some(isFormDirty)
    }
  }
)

export const getModalOptions = (state: any) => state.ui.modalOptions

export const selectPathname = (state: any): string => state.ui.locationPathname

export const selectPathnameWithoutLocale = createSelector(
  getCurrentLanguage,
  selectPathname,
  (locale: string, pathname): string => getPathnameWithoutLocale(locale, pathname)
)

export const selectPathnameSlug = createSelector(
  selectPathnameWithoutLocale,
  (pathname: string): string => trimSlug(pathname)
)
